
import types from "../mutation-types";
import CouponApi from '../../api/coupons'

export const state = {
    coupons: [],
    meta: {
        count: 0,
        currentPage: 1,
        pageSize: 15
    },
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isDeleting: false,
        isUpdating: false,
    },
    coupon_reports:[],
    couponDefaultList:[],
};

// list of getters
const getters = {
    getUIFlags(_state){
        return _state.uiFlags;
    },
    getMeta(_state){
        return _state.meta;
    },
    getCoupons(_state){
        return _state.coupons;
    },
    getCouponReports(_state){
        return _state.coupon_reports;
    },
    getDefaultCouponList(_state){
        return _state.couponDefaultList;
    },
}


// actions list
const actions = {
    getCoupons: async function({commit,state},query){
        commit(types.SET_COUPONS_UI_FLAG,{isFetching: true});
        try {
            const response = await CouponApi.getAllCoupons(query);
            commit(types.SET_COUPON_LIST, response.data?.data);
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        }
    },

    createCoupon: async function({commit,state},payload){
        commit(types.SET_COUPONS_UI_FLAG,{isCreating: true});
        try {
            const {data} = await CouponApi.createCoupon(payload);
            commit(types.SET_COUPON_CREATE,data);
            commit(types.SET_COUPONS_UI_FLAG,{isCreating: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_COUPONS_UI_FLAG,{isCreating: false});
            throw error;
        }
    },
    updateCouponById: async function({commit,state},{coupon_id,payload}){
        commit(types.SET_COUPONS_UI_FLAG,{isUpdating: true});
        try {
            const {data} = await CouponApi.updateCouponById(coupon_id,payload);
            commit(types.SET_COUPON_UPDATE,data);
            commit(types.SET_COUPONS_UI_FLAG,{isUpdating: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_COUPONS_UI_FLAG,{isUpdating: false});
            throw error;
        }
    },
    deleteCouponById: async function({commit,state},{coupon_id}){
        commit(types.SET_COUPONS_UI_FLAG,{isDeleting: true});
        try {
            const {data} = await CouponApi.deleteCouponById(coupon_id);
            commit(types.SET_COUPON_DELETE,coupon_id);
            commit(types.SET_COUPONS_UI_FLAG,{isDeleting: false});
            return data;
        } catch (error) {
            console.log(error);
            commit(types.SET_COUPONS_UI_FLAG,{isDeleting: false});
            throw error;
        }
    },
    getCouponReports: async function({commit},queryParams={}){
        commit(types.SET_COUPONS_UI_FLAG,{isFetching: true});
        try {
            const {data} = await CouponApi.getCouponReport(queryParams);
            commit(types.SET_COUPON_REPORTS,data);
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        } catch (error) {
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        }
    },

    fetchDefaultCoupons: async function({commit,state},query={}){
        commit(types.SET_COUPONS_UI_FLAG,{isFetching: true});
        try {
            const response = await CouponApi.getDefaultCoupons(query);
            commit(types.SET_COUPON_DEFAULT_LIST, response.data);
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        } catch (error) {
            console.log(error);
            commit(types.SET_COUPONS_UI_FLAG,{isFetching: false});
        }
    },

}


// list of mutations
const mutations = {
    // mutate UI flags
    [types.SET_COUPONS_UI_FLAG](_state, data) {
        _state.uiFlags = {
          ..._state.uiFlags,
          ...data,
        };
    },

    // create an coupon
    [types.SET_COUPON_CREATE]($state, data) {
        $state.coupons.unshift(data)
    },

    [types.SET_COUPON_LIST]($state, data) {
        $state.coupons = data;
    },
    [types.SET_COUPON_DEFAULT_LIST]($state, data) {
        $state.couponDefaultList = data;
    },
    [types.SET_COUPON_UPDATE]($state, data) {
        const index = $state.coupons.findIndex(coupon => coupon.id === data.id);
        if (index !== -1) {
            // Replace existing coupon
            $state.coupons.splice(index, 1, data);
        } else {
            // If not found, add the new coupon
            $state.coupons.push(data);
        }
    },
    [types.SET_COUPON_DELETE]($state, coupon_id) {
        const index = $state.coupons.findIndex(coupon => coupon.id === coupon_id);
        if (index !== -1) {
            $state.coupons.splice(index, 1);
        }
    },

    // set coupon reports
    [types.SET_COUPON_REPORTS]($state,data){
        $state.coupon_reports = data;
    },

}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}